// 定义用户角色枚举
const UserRole = {
    NH: 0,//"农户"
    // NF: 1,//"农服"
    NZ: 2,//"农资"
    EXPERT: 3,//"专家"
};

export const NH = UserRole.NH;
export const NZ = UserRole.NZ;
export const EXPERT = UserRole.EXPERT;
